export default __webpack_public_path__ + "static/media/election2018primary.f5ab7490.txt";